<section class="flex float-right">
  <div
    (click)="handleClick()"
    (keydown.enter)="handleClick()"
    class="flex place-items-center mt-2"
    tabindex="0"
  >
    <a
      class="high-contrast-theme text-xs md:inline-block underline"
      alt="search by billing page link"
    >
      <span>{{ 'tinc_billing_search_link_text' | translate }}</span>
    </a>
    <mat-icon
      svgIcon="dls-angle-plain-right-light"
      class="arrow high-contrast-theme"
    ></mat-icon>
  </div>
</section>
